<div class="automatic-schedule">
  <div class="automatic-schedule__heading">
    <div class="automatic-schedule__title title title--s">Скорректированное расписание</div>
    <app-checkbox class="automatic-schedule__full-timeline-toggle">
      <input type="checkbox" [checked]="showFullTimeline" (change)="showFullTimeline = $event.target.checked" />
      <checkbox-text>Показать актуальный план</checkbox-text>
    </app-checkbox>
  </div>

  <div class="automatic-schedule__legend" aria-label="Обозначения таймлайна">
    <div class="automatic-schedule__legend-item">
      <span class="automatic-schedule__legend-marker automatic-schedule__legend-marker--flexible"></span>
      <span>Гибкие слоты</span>
    </div>
    <div class="automatic-schedule__legend-item">
      <span class="automatic-schedule__legend-marker automatic-schedule__legend-marker--current"></span>
      <span>Текущие слоты</span>
    </div>
    <div class="automatic-schedule__legend-item" *ngIf="showFullTimeline">
      <span class="automatic-schedule__legend-marker automatic-schedule__legend-marker--actual"></span>
      <span>Актуальный план</span>
    </div>
  </div>

  <div class="automatic-schedule__empty" *ngIf="!getRoutes(result).length">Нет распределенных маршрутов для отображения.</div>

  <div class="automatic-schedule__table" *ngIf="getRoutes(result).length" #scheduleTable>
    <div class="automatic-schedule__header">
      <div class="automatic-schedule__employee-cell automatic-schedule__employee-cell--header">
        <div class="automatic-schedule__header-title">Сотрудник</div>
        <div class="automatic-schedule__timeline-controls">
          <button
            type="button"
            class="automatic-schedule__nav-btn"
            (click)="scrollTimeline(scheduleTable, -1)"
            [disabled]="!canScrollTimelineBackward(scheduleTable)"
            title="Раньше"
          >
            <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
          </button>
          <span class="automatic-schedule__timeline-range">{{ getTimelineRangeLabel(result) }}</span>
          <button
            type="button"
            class="automatic-schedule__nav-btn"
            (click)="scrollTimeline(scheduleTable, 1)"
            [disabled]="!canScrollTimelineForward(scheduleTable)"
            title="Позже"
          >
            <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
          </button>
        </div>
      </div>
      <div class="automatic-schedule__timeline-header" [style.width.px]="getTimelineWidth(result)">
        <div class="automatic-schedule__timeline-top">
          <div class="automatic-schedule__timeline-title">Рабочее время</div>
        </div>
        <div class="automatic-schedule__timeline">
          <div class="automatic-schedule__hour" *ngFor="let hour of getTimelineHours(result)">{{ hour }}:00</div>
        </div>
      </div>
    </div>

    <div
      class="automatic-schedule__row"
      [class.automatic-schedule__row--trip]="isRouteEmployeeOnTrip(route, result)"
      [class.automatic-schedule__row--gph]="isRouteEmployeeGph(route, result)"
      *ngFor="let route of getRoutes(result); trackBy: trackByRoute"
    >
      <div class="automatic-schedule__employee-cell" [style.min-height.px]="getRouteRowHeight(route)">
        <div class="automatic-schedule__employee-name">
          <span class="automatic-schedule__employee-identity">
            <span>{{ route.employee_name }}</span>
            <span class="automatic-schedule__employee-badge automatic-schedule__employee-badge--trip" *ngIf="isRouteEmployeeOnTrip(route, result)">
              Командирован
            </span>
            <span class="automatic-schedule__employee-badge automatic-schedule__employee-badge--gph" *ngIf="isRouteEmployeeGph(route, result)">
              ГПХ
            </span>
          </span>
          <span class="automatic-schedule__employee-transport">
            <app-icon
              [glyph]="getRouteTransportIcon(route, result)"
              [size]="'16'"
              [attr.title]="getRouteTransportTitle(route, result)"
            ></app-icon>
          </span>
        </div>
        <div class="automatic-schedule__employee-time">{{ getEmployeeWorkTime(route) }}</div>
        <div class="automatic-schedule__employee-count">Заявок: {{ getRouteOrdersCount(route) }}</div>
        <div class="automatic-schedule__employee-distance" *ngIf="getRouteDistance(route)">Путь: {{ getRouteDistance(route) }}</div>
        <div class="automatic-schedule__employee-efficiency">Эффективность планирования: {{ getRouteEfficiencyPercent(route, result) }}</div>
      </div>

      <div
        class="automatic-schedule__route-line"
        #routeLine
        [style.width.px]="getTimelineWidth(result)"
        [style.min-height.px]="getRouteRowHeight(route)"
      >
        <div class="automatic-schedule__route-grid">
          <div class="automatic-schedule__route-grid-cell" *ngFor="let hour of getTimelineHours(result)"></div>
        </div>
        <div class="automatic-schedule__no-orders" *ngIf="!getRouteOrdersCount(route)">Нет заявок на маршруте</div>
        <div class="automatic-schedule__no-orders" *ngIf="getRouteOrdersCount(route) && !getVisibleRouteOrdersCount(route, result)">Нет заявок в выбранное время</div>

        <div
          class="automatic-schedule__travel"
          *ngFor="let travel of getVisibleRouteTravels(route, result); trackBy: trackByTravel"
          [style.right.%]="getTravelRightPercent(travel, result)"
          [style.width.%]="getTravelDisplayWidthPercent(travel, result, routeLine)"
          [class.automatic-schedule__travel--compact]="isTravelCompact(travel, result, routeLine)"
          title="{{ getTravelTitle(travel) }}"
        >
          <ng-container *ngIf="!isTravelCompact(travel, result, routeLine); else compactTravel">
            <div class="automatic-schedule__travel-name">{{ getTravelLabel(travel) }}</div>
            <div class="automatic-schedule__travel-meta">{{ getTravelTimeLabel(travel) }}</div>
          </ng-container>
          <ng-template #compactTravel>
            <app-icon
              [glyph]="getRouteTransportIcon(route, result)"
              [size]="'16'"
              [attr.title]="getRouteTransportTitle(route, result)"
            ></app-icon>
          </ng-template>
        </div>

        <div
          class="automatic-schedule__order"
          *ngFor="let order of getVisibleRouteOrders(route, result); trackBy: trackByOrder"
          [style.left.%]="getOrderLeftPercent(order, result)"
          [style.width.%]="getOrderWidthPercent(order, result)"
          title="Гибкие слоты: {{ order.order_name || 'Заявка' }} № {{ getOrderNumber(order) }}. Интервал: {{ getOrderTimeRange(order) }}{{
            getOrderOriginalTimeRange(order) ? '. Изначально: ' + getOrderOriginalTimeRange(order) : ''
          }}{{ getOrderAddressTitlePart(order) }}"
        >
          <div class="automatic-schedule__order-name">Гибкие слоты: {{ order.order_name || 'Заявка' }}</div>
          <div class="automatic-schedule__order-meta">
            <ng-container *ngIf="getOrderLink(order) as orderLink; else orderNumberText">
              <a class="automatic-schedule__order-link" [routerLink]="orderLink" [title]="'Открыть заявку № ' + getOrderNumber(order)">
                № {{ getOrderNumber(order) }}
              </a>
            </ng-container>
            <ng-template #orderNumberText>
              <span>№ {{ getOrderNumber(order) }}</span>
            </ng-template>
            <span class="automatic-schedule__order-separator">·</span>
            <span>{{ getOrderTimeRange(order) }}</span>
          </div>
        </div>

        <div
          class="automatic-schedule__order automatic-schedule__order--planned"
          *ngFor="let plannedOrder of getVisibleRouteOriginalOrderLayouts(route, result); trackBy: trackByPlannedOrder"
          [style.left.%]="getOrderOriginalLeftPercent(plannedOrder.order, result)"
          [style.width.%]="getOrderOriginalWidthPercent(plannedOrder.order, result)"
          [style.top.px]="getPlannedOrderTop(plannedOrder.lane)"
          title="Текущие слоты: {{ plannedOrder.order.order_name || 'Заявка' }} № {{ getOrderNumber(plannedOrder.order) }}. Интервал: {{
            getOrderOriginalTimeRange(plannedOrder.order)
          }}{{ getOrderAddressTitlePart(plannedOrder.order) }}"
        >
          <div class="automatic-schedule__order-name">Текущие слоты: {{ plannedOrder.order.order_name || 'Заявка' }}</div>
          <div class="automatic-schedule__order-meta">
            <span>№ {{ getOrderNumber(plannedOrder.order) }}</span>
            <span class="automatic-schedule__order-separator">·</span>
            <span>{{ getOrderOriginalTimeRange(plannedOrder.order) }}</span>
          </div>
        </div>

        <div
          class="automatic-schedule__additional-timeline"
          *ngIf="showFullTimeline"
          [style.top.px]="getAdditionalTimelineTop(route)"
          [style.height.px]="getAdditionalTimelineHeight(route)"
          aria-label="Актуальный план"
        ></div>

        <ng-container *ngIf="showFullTimeline">
          <div
            class="automatic-schedule__order automatic-schedule__order--original-assignment"
            *ngFor="let originalAssignment of getOriginalAssignmentsLayout(route, result).items; trackBy: trackByOriginalAssignment"
            [style.left.%]="getOriginalAssignmentLeftPercent(originalAssignment.order, result)"
            [style.width.%]="getOriginalAssignmentWidthPercent(originalAssignment.order, result)"
            [style.top.px]="getOriginalAssignmentTop(route, originalAssignment.lane)"
            title="Актуальный план: {{ originalAssignment.order.name || originalAssignment.order.order_name || 'Заявка' }} № {{ getOrderNumber(originalAssignment.order) }}. Интервал: {{
              getOriginalAssignmentTimeRange(originalAssignment.order)
            }}{{ getOrderAddressTitlePart(originalAssignment.order) }}"
          >
            <div class="automatic-schedule__order-name">
              Актуальный план: {{ originalAssignment.order.name || originalAssignment.order.order_name || 'Заявка' }}
            </div>
            <div class="automatic-schedule__order-meta">
              <ng-container *ngIf="getOrderLink(originalAssignment.order) as orderLink; else originalAssignmentNumberText">
                <a class="automatic-schedule__order-link" [routerLink]="orderLink" [title]="'Открыть заявку № ' + getOrderNumber(originalAssignment.order)">
                  № {{ getOrderNumber(originalAssignment.order) }}
                </a>
              </ng-container>
              <ng-template #originalAssignmentNumberText>
                <span>№ {{ getOrderNumber(originalAssignment.order) }}</span>
              </ng-template>
              <span class="automatic-schedule__order-separator">·</span>
              <span>{{ getOriginalAssignmentTimeRange(originalAssignment.order) }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
